import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'shared-message-sender',
  standalone: true,
  imports: [],
  templateUrl: './message-sender.component.html',
  styleUrl: './message-sender.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageSenderComponent {
  sender = input.required<string>();
}
